import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import { handleError } from './user';
import formatDate from '../services/formatDate';
import mixpanelConstants from '../constants/mixpanel';
import constants from '../services/constants';
import moment from 'moment';
import { getNurseShiftHistory } from './admin/user';

export const setnursedashboard = createAction('SET_NURSE_DASHBOARD');
export const setorganizations = createAction('SET_ORGANIZATIONS');
export const setlocations = createAction('SET_LOCATIONS');
export const setDepartments = createAction('SET_DEPARTMENTS');
export const clearlocations = createAction('CLEAR_LOCATIONS');
export const clearorganizations = createAction('CLEAR_ORGANIZATIONS');
export const cleardepartments = createAction('CLEAR_DEPARTMENTS');
export const clearstatus = createAction('CLEAR_STATUS');
export const clearsupervisors = createAction('CLEAR_SUPERVISORS');
export const clearStartDate = createAction('CLEAR_STARTDATE');
export const clearEndDate = createAction('CLEAR_ENDDATE');
export const clearDistance = createAction('CLEAR_DISTANCE');
export const clearZipCode = createAction('CLEAR_ZIPCODE');
export const setnotifications = createAction('SET_NOTIFICATIONS');
export const setnoticecount = createAction('SET_NOTICECOUNT');
export const setcountdisplay = createAction('SETCOUNTDISPLAY');
export const setsupervisor = createAction('SET_SUPERVISOR');
export const setuserinfo = createAction('SET_USERINFO');

export const changeStatus = createAction('CHANGE_LIST_STATUS');
export const changeOrganization = createAction('CHANGE_ORGANIZATION');
export const changeLocation = createAction('CHANGE_LOCATION');
export const changeDepartment = createAction('CHANGE_DEPARTMENT');
export const changeSupervisor = createAction('CHANGE_SUPERVISOR');
export const setStartDate = createAction('SET_START_DATE');
export const setEndDate = createAction('SET_END_DATE');
export const setZipcode = createAction('SET_ZIPCODE');
export const setDistance = createAction('SET_DISTANCE');
export const setPageNumber = createAction('SET_PAGE_NUMBER');

export const clearorgList = createAction('CLEAR_ORGLIST');
export const cleardeptList = createAction('CLEAR_DEPTLIST');
export const clearlocList = createAction('CLEAR_LOCLIST');
export const clearSupervisorList = createAction('CLEAR_SUPERVISORLIST');
export const setNoticeStatus = createAction('SET_NOTICESSTATUS');

export const clearNurseDashboard = createAction('CLEAR_NURSE_DASHBOARD');
export const clearNotification = createAction('CLEAR_NOTIFICATION');
export const clearUserInfo = createAction('CLEAR_USERINFO');

export const setSort = createAction('SET_SORT');
export const setSortOrder = createAction('SET_SORT_ORDER');

export const shiftsListDisplay = createAction('SHIFTS_LIST_DISPLAY');
export const setCompletedHrs = createAction('TOTAL_COMPLETED_SHIFTS_HRS');
export const setFilteredCompletedHrs = createAction('FILTER_COMPLETED_SHIFTS_HRS');
export const setApprovalStatus = createAction('SET_APPROVAL_STATUS');
export const setShiftID = createAction('SET_SHIFT_ID');
export const setShiftAcceptedStatus = createAction('SET_SHIFT_ACCEPTED_STATUS');
export const setIsFetchingOrg = createAction('SET_IS_FETCHING');
export const setExpirationList = createAction('SET_EXPIRATION_LIST');
export const setIsFromExpireBanner = createAction('SET_ISFROM_EXPIRE_BANNER');
export const setJobHistoryAsDefaultTab = createAction('SET_JOB_HISTORY_AS_DEFAULT_TAB');
export const setIsFetchingUser = createAction('SET_IS_FETCHING_USER');
export const setFiltersList = createAction('SET_FILTER_LIST');
export const setDaysList = createAction('SET_DAYS_LIST');
export const setLocationIdsList = createAction('SET_LOCATIONIDS_LIST');
export const setTimesList = createAction('SET_TIMES_LIST');
export const setOpenShift_from_date = createAction('SET_OPENSHIFT_FROM_DATE');
export const setOpenShift_end_date = createAction('SET_OPENSHIFT_END_DATE');
export const setFilterName = createAction('SET_FILTER_NAME');
export const setSavedFilter = createAction('SET_SAVED_FILTER');
export const setOpenShiftSearchTerm = createAction('SET_OPEN_SHIFT_SEARCH_TERM');
export const setIs_any_updation = createAction('SET_IS_UPDATION');
export const setOpenWithdrawReasonPopup = createAction('SET_OPEN_WITHDRAW_REASON_POPUP');
export const setOpenCalloutReasonPopup = createAction('SET_OPEN_CALLOUT_REASON_POPUP');
export const setReasonValue = createAction('SET_REASON_VALUE');
export const setReasons = createAction('SET_REASONS');
export const setActionShiftId = createAction('SET_ACTION_SHIFTID');
export const setExcludeWaitlistShifts = createAction('SET_EXCLUDE_WAITLIST_SHIFTS');
export const setOnlyRecommendedShifts = createAction('SET_ONLY_RECOMMENDED_SHIFTS');

const initialState = {
	acceptedStatus: '',
	actionShiftId: '',
	approvalStatus: '',
	days: [],
	departments: [],
	dept: '',
	display: 'none',
	distance: constants.defaultDistanceValue,
	excludeWaitlist: false,
	expirationList: [],
	filter_name: '',
	filterCompletedHrs: '',
	filterList: [],
	from_date: '',
	info: {},
	is_any_updation: false,
	isFetchingOrg: '',
	isFetchingUser: false,
	isFromExpireBanner: false,
	isJobHistorySetAsDefault: false,
	loc: '',
	locationids: [],
	locations: [],
	noticeCount: {},
	notifications: [],
	notificationStatus: 'Loading...',
	nursedashboardList: {},
	onlyRecommended: false,
	openCalloutReasonPopup: false,
	openShift_from_date: '',
	openShift_to_date: '',
	openShiftSearchTerm: '',
	openWithdrawReasonPopup: false,
	org: '',
	organizations: [],
	page_no: 1,
	reasons: [],
	reasonValue: '',
	savedFilter: [],
	shiftID: '',
	sort: '',
	sortorder: '',
	status: '',
	supervisor: '',
	supervisorsList: [],
	times: [],
	to_date: '',
	totalCompletedHrs: '',
	zip_code: ''
};

export default handleActions(
	{
		CHANGE_DEPARTMENT: (state, action) => ({ ...state, dept: action.payload }),
		CHANGE_LIST_STATUS: (state, action) => ({ ...state, status: action.payload }),
		CHANGE_LOCATION: (state, action) => ({ ...state, loc: action.payload }),
		CHANGE_ORGANIZATION: (state, action) => ({ ...state, org: action.payload }),
		CHANGE_SUPERVISOR: (state, action) => ({ ...state, supervisor: action.payload }),
		CLEAR_DEPARTMENTS: (state) => ({ ...state, dept: initialState.dept }),
		CLEAR_DEPTLIST: (state) => ({ ...state, departments: initialState.departments }),
		CLEAR_DISTANCE: (state) => ({ ...state, distance: initialState.distance }),
		CLEAR_ENDDATE: (state) => ({ ...state, to_date: initialState.to_date }),
		CLEAR_LOCATIONS: (state) => ({ ...state, loc: initialState.loc }),
		CLEAR_LOCLIST: (state) => ({ ...state, locations: initialState.locations }),
		CLEAR_NOTIFICATION: (state) => ({ ...state, notifications: initialState.notifications }),
		CLEAR_NURSE_DASHBOARD: (state) => ({ ...state, nursedashboardList: initialState.nursedashboardList }),
		CLEAR_ORGANIZATIONS: (state) => ({ ...state, org: initialState.org }),
		CLEAR_ORGLIST: (state) => ({ ...state, organizations: initialState.organizations }),
		CLEAR_STARTDATE: (state) => ({ ...state, from_date: initialState.from_date }),
		CLEAR_STATUS: (state) => ({ ...state, status: initialState.status }),
		CLEAR_SUPERVISORLIST: (state) => ({ ...state, supervisorsList: initialState.supervisorsList }),
		CLEAR_SUPERVISORS: (state) => ({ ...state, supervisor: initialState.supervisor }),
		CLEAR_USERINFO: (state) => ({ ...state, info: initialState.info }),
		CLEAR_ZIPCODE: (state) => ({ ...state, zip_code: initialState.zip_code }),
		FILTER_COMPLETED_SHIFTS_HRS: (state, action) => ({ ...state, filterCompletedHrs: action.payload }),
		SET_ACTION_SHIFTID: (state, action) => ({ ...state, actionShiftId: action.payload }),
		SET_APPROVAL_STATUS: (state, action) => ({ ...state, approvalStatus: action.payload }),
		SET_DAYS_LIST: (state, action) => ({ ...state, days: action.payload }),
		SET_DEPARTMENTS: (state, action) => ({ ...state, departments: action.payload }),
		SET_DISTANCE: (state, action) => ({ ...state, distance: action.payload }),
		SET_END_DATE: (state, action) => ({ ...state, to_date: action.payload }),
		SET_EXCLUDE_WAITLIST_SHIFTS: (state, action) => ({ ...state, excludeWaitlist: action.payload }),
		SET_EXPIRATION_LIST: (state, action) => ({ ...state, expirationList: action.payload }),
		SET_FILTER_LIST: (state, action) => ({ ...state, filterList: action.payload }),
		SET_FILTER_NAME: (state, action) => ({ ...state, filter_name: action.payload }),
		SET_IS_FETCHING: (state, action) => ({ ...state, isFetchingOrg: action.payload }),
		SET_IS_FETCHING_USER: (state, action) => ({ ...state, isFetchingUser: action.payload }),
		SET_IS_UPDATION: (state, action) => ({ ...state, is_any_updation: action.payload }),
		SET_ISFROM_EXPIRE_BANNER: (state, action) => ({ ...state, isFromExpireBanner: action.payload }),
		SET_JOB_HISTORY_AS_DEFAULT_TAB: (state, action) => ({ ...state, isJobHistorySetAsDefault: action.payload }),
		SET_LOCATIONIDS_LIST: (state, action) => ({ ...state, locationids: action.payload }),
		SET_LOCATIONS: (state, action) => ({ ...state, locations: action.payload }),
		SET_NOTICECOUNT: (state, action) => ({ ...state, noticeCount: action.payload }),
		SET_NOTICESSTATUS: (state, action) => ({ ...state, notificationStatus: action.payload }),
		SET_NOTIFICATIONS: (state, action) => ({ ...state, notifications: action.payload }),
		SET_NURSE_DASHBOARD: (state, action) => ({ ...state, nursedashboardList: action.payload }),
		SET_ONLY_RECOMMENDED_SHIFTS: (state, action) => ({ ...state, onlyRecommended: action.payload }),
		SET_OPEN_CALLOUT_REASON_POPUP: (state, action) => ({ ...state, openCalloutReasonPopup: action.payload }),
		SET_OPEN_SHIFT_SEARCH_TERM: (state, action) => ({ ...state, openShiftSearchTerm: action.payload }),
		SET_OPEN_WITHDRAW_REASON_POPUP: (state, action) => ({ ...state, openWithdrawReasonPopup: action.payload }),
		SET_OPENSHIFT_END_DATE: (state, action) => ({ ...state, openShift_to_date: action.payload }),
		SET_OPENSHIFT_FROM_DATE: (state, action) => ({ ...state, openShift_from_date: action.payload }),
		SET_ORGANIZATIONS: (state, action) => ({ ...state, organizations: action.payload }),
		SET_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_REASON_VALUE: (state, action) => ({ ...state, reasonValue: action.payload }),
		SET_REASONS: (state, action) => ({ ...state, reasons: action.payload }),
		SET_REQUIREDNOTIFICATIONS: (state, action) => ({ ...state, notifications: action.payload }),
		SET_SAVED_FILTER: (state, action) => ({ ...state, savedFilter: action.payload }),
		SET_SHIFT_ACCEPTED_STATUS: (state, action) => ({ ...state, acceptedStatus: action.payload }),
		SET_SHIFT_ID: (state, action) => ({ ...state, shiftID: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortorder: action.payload }),
		SET_START_DATE: (state, action) => ({ ...state, from_date: action.payload }),
		SET_SUPERVISOR: (state, action) => ({ ...state, supervisorsList: action.payload }),
		SET_TIMES_LIST: (state, action) => ({ ...state, times: action.payload }),
		SET_USERINFO: (state, action) => ({ ...state, info: action.payload }),
		SET_ZIPCODE: (state, action) => ({ ...state, zip_code: action.payload }),
		SETCOUNTDISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SHIFTS_LIST_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		TOTAL_COMPLETED_SHIFTS_HRS: (state, action) => ({ ...state, totalCompletedHrs: action.payload })
	},
	initialState
);

export const clearValues = () => {
	return function (dispatch, getState) {
		dispatch(setPageNumber(1));
		dispatch(clearlocations());
		dispatch(clearorganizations());
		dispatch(cleardepartments());
		dispatch(clearsupervisors());
		dispatch(clearStartDate());
		dispatch(clearEndDate());
		dispatch(setDistance(constants.defaultDistanceValue));
		dispatch(setZipcode(getState().nurseshift.info.zip));
		dispatch(setApprovalStatus(''));
		dispatch(setFilteredCompletedHrs(''));
		dispatch(setCompletedHrs(''));
		dispatch(setShiftID(''));
		dispatch(setShiftAcceptedStatus(''));
		dispatch(setSort(''));
		dispatch(setSortOrder(''));
		dispatch(setExpirationList([]));
	};
};
export const pageNumber = (pageNo) => {
	return function (dispatch) {
		dispatch(setPageNumber(pageNo));
	};
};

export const organization = () => {
	return function (dispatch) {
		dispatch(setIsFetchingOrg(true));
		Agent.organization().then((response) => {
			if (response.ok) {
				response.data.sort(function (a, b) {
					if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
					if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
					return 0;
				});
				dispatch(setorganizations(response.data));
				dispatch(setIsFetchingOrg(false));
			} else {
				dispatch(setIsFetchingOrg(false));
				dispatch(handleError(response));
			}
		});
	};
};

export const notification = () => {
	return function (dispatch) {
		Agent.notices().then((response) => {
			if (response.ok) {
				dispatch(setnotifications(response.data));
				dispatch(count());
				if (response.data.length === 0) {
					dispatch(setNoticeStatus('You have no notifications.'));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const count = () => {
	return function (dispatch) {
		Agent.noticeCount().then((response) => {
			if (response.ok) {
				dispatch(setnoticecount(response.data));
				if (response.data.notice_count > 0) {
					dispatch(setcountdisplay('block'));
				} else {
					dispatch(setcountdisplay('none'));
				}
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const removeNotices = (id) => {
	return function (dispatch, getState) {
		Agent.deleteNotices(id).then((response) => {
			if (response.ok) {
				let notif = getState().nurseshift.notifications.filter((ntf) => ntf.id == id)[0];
				mixpanel.track(mixpanelConstants.REMOVE_notif, {
					actionAdjective: notif.action_adjective,
					actionSubject: notif.action_subject,
					actionVerb: notif.action_verb,
					id: id,
					title: notif.notification_text
				});
				dispatch(notification());
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const supervisor = (id, locid) => {
	return function (dispatch) {
		Agent.supervisors(id, locid).then((response) => {
			if (response.ok) {
				dispatch(setsupervisor(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const userInfo = (fromDash) => {
	return function (dispatch) {
		dispatch(setIsFetchingUser(true));
		Agent.userinfo().then((response) => {
			if (response.ok) {
				dispatch(setuserinfo(response.data));
				dispatch(setZipcode(response.data.zip));
				if (fromDash != undefined) {
					dispatch(shiftsListDisplay('block'));
				}
				dispatch(setIsFetchingUser(false));
			} else {
				dispatch(handleError(response));
				dispatch(setIsFetchingUser(false));
			}
		});
	};
};

export const calloutApplicationNurse = () => {
	return function (dispatch, getState) {
		const { reasonValue, actionShiftId } = getState().nurseshift;
		Agent.calloutShiftByAdmin(actionShiftId, reasonValue, getState().globalUser.user_id).then((response) => {
			if (response.ok) {
				let shiftDetails = getState().shiftdetail.shiftDetails;
				mixpanel.track(mixpanelConstants.CANCEL_SHIFT, {
					address: shiftDetails.address,
					city: shiftDetails.city,
					organization: shiftDetails.organization,
					organizationId: shiftDetails.organization_id,
					roleList: shiftDetails.role_list,
					shiftId: actionShiftId
				});
				dispatch(getNurseShiftHistory({ sort_by: 'shift_date' }));
			} else {
				if (response.status !== 401) {
					alert(response.data);
				} else {
					dispatch(handleError(response.data));
				}
			}
		});
	};
};

export const getCredentialExpireList = () => {
	return function (dispatch) {
		Agent.checkCredentialExpire().then((response) => {
			if (response.ok) {
				dispatch(setExpirationList(response.data));
			} else {
			}
		});
	};
};

export const getFilterList = () => {
	return function (dispatch) {
		Agent.getFilters().then((response) => {
			if (response.ok) {
				dispatch(setFiltersList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const savefilter = () => {
	return function (dispatch, getState) {
		const {
			filter_name,
			days,
			locationids,
			times,
			openShift_from_date,
			openShift_to_date,
			filterList,
			distance,
			zip_code,
			excludeWaitlist,
			onlyRecommended
		} = getState().nurseshift;
		const { dateFilterFormat } = formatDate;

		if (filter_name === '') {
			alert('Please enter a filter name');
			return;
		}

		let values = [];

		filterList.map((obj) => {
			if (obj.id == constants.Days) {
				obj.options.map((optEle) => {
					if (days.length > 0) {
						days.map((days_reco_id) => {
							if (optEle.recognize_id == days_reco_id) {
								values.push({ filter_option_id: optEle.id, value: days_reco_id.toString() });
							}
						});
					}
				});
			}
			if (obj.id == constants.Time) {
				obj.options.map((optEle) => {
					if (times.length > 0) {
						times.map((time_reco_id) => {
							if (optEle.recognize_id == time_reco_id) {
								values.push({ filter_option_id: optEle.id, value: time_reco_id.toString() });
							}
						});
					}
				});
			}

			if (obj.id == constants.Location) {
				obj.options.map((optEle) => {
					if (locationids.length > 0) {
						locationids.map((loc_reco_id) => {
							if (optEle.recognize_id == loc_reco_id) {
								values.push({ filter_option_id: optEle.id, value: loc_reco_id.toString() });
							}
						});
					}
				});
			}

			if (obj.id == constants.Miles) {
				obj.options.map((optEle) => {
					if (zip_code !== '') {
						if (optEle.option_name == constants.Zipcode) {
							values.push({ filter_option_id: optEle.id, value: zip_code.toString() });
						}
						if (optEle.option_name == constants.Distance) {
							values.push({ filter_option_id: optEle.id, value: distance.toString() });
						}
					}
				});
			}

			if (obj.id == constants.Date) {
				obj.options.map((optEle) => {
					if (openShift_from_date) {
						if (optEle.option_name == constants.FromDate) {
							values.push({ filter_option_id: optEle.id, value: dateFilterFormat(openShift_from_date) });
						}
					}
					if (openShift_to_date) {
						if (optEle.option_name == constants.ToDate) {
							values.push({ filter_option_id: optEle.id, value: dateFilterFormat(openShift_to_date) });
						}
					}
				});
			}

			if (obj.id == constants.ExcludeWaitlist) {
				obj.options.map((optEle) => {
					values.push({ filter_option_id: optEle.id, value: excludeWaitlist.toString() });
				});
			}

			if (obj.id == constants.RecommendedShifts) {
				obj.options.map((optEle) => {
					values.push({ filter_option_id: optEle.id, value: onlyRecommended.toString() });
				});
			}
		});

		Agent.savefilter(filter_name, false, values).then((response) => {
			if (response.ok) {
				alert('Filter saved successfully.');
				dispatch(getSavedFilter());
			} else {
				alert(response.data);
				dispatch(handleError(response));
			}
		});
	};
};

export const getSavedFilter = () => {
	return function (dispatch, getState) {
		const { days, locationids, times, openShift_from_date, openShift_to_date, distance, zip_code, is_any_updation } =
			getState().nurseshift;
		Agent.getSavedFilter().then((response) => {
			if (response.ok) {
				dispatch(setSavedFilter(response.data));

				response.data.forEach((obj) => {
					if (obj.is_default) {
						let daysFilter = [];
						let timeFilter = [];
						let _distFilterZipCode = '';
						let _distFilterDisValue = constants.defaultDistanceValue;
						let specFilter = [];
						let locsFilter = [];
						let _fromDateFilter = '';
						let _toDateFilter = '';
						let _excludeWaitlist = false;
						let _onlyRecommended = false;

						const { filterList } = getState().nurseshift;

						if (
							!is_any_updation &&
							days.length === 0 &&
							times.length === 0 &&
							locationids.length === 0 &&
							distance == parseInt(constants.defaultDistanceValue) &&
							zip_code === getState().nurseshift.info.zip &&
							openShift_from_date === '' &&
							openShift_to_date === ''
						) {
							obj.values.map((saveValueObj) => {
								filterList.map((option) => {
									option.options.map((optEle) => {
										if (saveValueObj.filter_option_id === optEle.id) {
											if (optEle.filter_id == 1) {
												daysFilter.push(parseInt(saveValueObj.value));
											} else if (optEle.filter_id == 2) {
												timeFilter.push(parseInt(saveValueObj.value));
											} else if (optEle.filter_id == 3) {
												locsFilter.push(parseInt(saveValueObj.value));
											} else if (optEle.filter_id == 4) {
												specFilter.push(parseInt(saveValueObj.value));
											} else if (optEle.filter_id == 5) {
												if (optEle.option_name == constants.Zipcode) {
													_distFilterZipCode = saveValueObj.value;
												} else if (optEle.option_name == constants.Distance) {
													_distFilterDisValue = saveValueObj.value;
												}
											} else if (optEle.filter_id == 6) {
												if (optEle.option_name == constants.ToDate) {
													const fromDate = moment(saveValueObj.value).format('MM/DD/YYYY');
													_toDateFilter = fromDate;
												} else if (optEle.option_name == constants.FromDate) {
													_fromDateFilter = moment(saveValueObj.value).format('MM/DD/YYYY');
												}
											} else if (optEle.filter_id == constants.ExcludeWaitlist) {
												_excludeWaitlist = saveValueObj.value == 'true' ? true : false;
											} else if (optEle.filter_id == constants.RecommendedShifts) {
												_onlyRecommended = saveValueObj.value == 'true' ? true : false;
											}
											return;
										}
									});
								});
							});

							dispatch(setDaysList(daysFilter));
							dispatch(setTimesList(timeFilter));
							dispatch(setLocationIdsList(locsFilter));
							dispatch(setZipcode(_distFilterZipCode));
							dispatch(setDistance(_distFilterDisValue));
							dispatch(setOpenShift_from_date(_fromDateFilter));
							dispatch(setOpenShift_end_date(_toDateFilter));
							dispatch(setExcludeWaitlistShifts(_excludeWaitlist));
							dispatch(setOnlyRecommendedShifts(_onlyRecommended));

							dispatch(shiftsListDisplay('block'));
						}
					}
				});
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const deleteFilter = (id) => {
	return function (dispatch) {
		Agent.deleteFilter(id).then((response) => {
			if (response.ok) {
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const getReasons = (type) => {
	return function (dispatch) {
		Agent.getDNRReason(type).then((response) => {
			if (response.ok) {
				dispatch(setReasons(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
